import type { SupplierCandidate } from './types';

function valueOf(candidate: SupplierCandidate, ...keys: string[]): unknown {
  for (const key of keys) {
    const value = candidate[key];
    if (value != null && String(value).trim() !== '') return value;
  }
  return null;
}

export function supplierCandidateId(candidate: SupplierCandidate): string {
  return String(valueOf(candidate, 'supplier_id', 'SUPPLIER_ID') ?? '');
}

export function supplierCandidateCode(candidate: SupplierCandidate): string {
  return String(valueOf(candidate, 'supplier_code', 'SUPPLIER_CODE') ?? '');
}

export function supplierCandidateName(candidate: SupplierCandidate): string {
  return String(
    valueOf(candidate, 'company_name', 'COMPANY_NAME', 'supplier', 'vendor') ?? '',
  );
}

export function supplierCandidateNtn(candidate: SupplierCandidate): string {
  return String(valueOf(candidate, 'ntn_no', 'NTN_NO', 'supplier_ntn', 'ntn') ?? '');
}

export function supplierCandidateBank(candidate: SupplierCandidate): string {
  return String(valueOf(candidate, 'bank_account_number', 'BANK_ACCOUNT_NUMBER') ?? '');
}

export function supplierCandidateCategory(candidate: SupplierCandidate): string {
  return String(valueOf(candidate, 'supp_catag_id', 'SUPP_CATAG_ID') ?? '');
}

export function supplierCandidateMatch(candidate: SupplierCandidate): string {
  return String(valueOf(candidate, 'match_type', 'MATCH_TYPE') ?? '');
}
